import { Link, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, 
  Upload, 
  FileText, 
  Archive, 
  Settings,
  Headset,
  LogOut,
  ChevronRight
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import PrelitXLogo from "@/components/PrelitXLogo";

const Sidebar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: LayoutDashboard,
    },
    {
      name: "Upload Records",
      path: "/upload",
      icon: Upload,
    },
    {
      name: "View Summaries",
      path: "/summaries",
      icon: FileText,
    },
    {
      name: "Archives",
      path: "/archives",
      icon: Archive,
    },
    {
      name: "Account Settings",
      path: "/settings",
      icon: Settings,
    },
    {
      name: "Support Tickets",
      path: "/support-tickets",
      icon: Headset,
    },
  ];

  const isActive = (path) => {
    if (path === "/dashboard") {
      return location.pathname === "/" || location.pathname === "/dashboard" || location.pathname.startsWith("/case/");
    }
    if (path === "/support-tickets") {
      return location.pathname === path || location.pathname.startsWith("/support-tickets/");
    }
    return location.pathname === path;
  };

  return (
    <div 
      className="fixed left-0 top-0 h-screen w-64 glass-card border-r-0 flex flex-col"
      style={{ borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}
    >
      {/* Logo Section */}
      <div className="p-6 border-b" style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}>
        <PrelitXLogo size="small" />
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 px-3 py-6 space-y-1 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center justify-between px-4 py-3 rounded-lg transition-all group ${
                active ? 'shadow-md' : 'hover:shadow-sm'
              }`}
              style={{
                backgroundColor: active ? 'rgba(36, 84, 81, 0.15)' : 'transparent',
                color: active ? '#245451' : '#64748B',
              }}
            >
              <div className="flex items-center space-x-3">
                <Icon className={`h-5 w-5 ${active ? 'text-[#245451]' : 'text-[#84a2ac]'}`} />
                <span className={`font-medium ${active ? 'text-[#245451]' : 'text-[#64748B]'}`}>
                  {item.name}
                </span>
              </div>
              {active && <ChevronRight className="h-4 w-4" style={{ color: '#C49603' }} />}
            </Link>
          );
        })}
      </nav>

      {/* Logout Button */}
      <div className="p-4 border-t" style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}>
        <button
          onClick={logout}
          className="flex items-center space-x-3 px-4 py-3 rounded-lg w-full transition-all hover:shadow-sm"
          style={{ color: '#64748B' }}
        >
          <LogOut className="h-5 w-5" style={{ color: '#84a2ac' }} />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
